import { useTranslate } from '@bynder/localization';
import { EmptyState, Flex } from '@bynder/design-system';
import { IconEdit } from '@bynder/icons';

const EmptyGuide = () => {
  const { translate } = useTranslate();

  return (
    <Flex direction="column" justifyContent="center" alignItems="center">
      <EmptyState
        icon={<IconEdit />}
        title={translate('EMPTY_GUIDE.TITLE')}
        text={translate('EMPTY_GUIDE.SUBTITLE')}
      />
    </Flex>
  );
};

export default EmptyGuide;
